var business = {};
module['exports'] = business;
business.credit_card_types = require('./credit_card_types');
